import { render, staticRenderFns } from "./AppFamilyMember.vue?vue&type=template&id=213b0ce5&"
import script from "./AppFamilyMember.vue?vue&type=script&lang=js&"
export * from "./AppFamilyMember.vue?vue&type=script&lang=js&"
import style0 from "./AppFamilyMember.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports